document.addEventListener("DOMContentLoaded", () => {
  try {

    import ("../../common/index");
    import ("../../common/copy-button/copy-link-button");

    console.log("DOMContentLoaded, on single template page");
  } catch (error) {
    console.error("An error occurred while loading the files on single template page", error);
  }
});
